document.addEventListener('DOMContentLoaded', function () {
    
    const swiperInitInterval = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(swiperInitInterval);
        const navigation_image_slider = new Swiper('.navigation_image_slider', {
          loop: false,
          autoplay: false,
          watchSlidesProgress: true,
          slidesPerView: 4,
          spaceBetween: 15,
          breakpoints: {
            768: {
              slidesPerView: 4
            },
            1200: {
              slidesPerView: 4
            }
          }
        });

        const featured_image_slider = new Swiper('.featured_image_slider', {
          loop: false,
          autoplay: false,
          thumbs: {
            swiper: navigation_image_slider,
            multipleActiveThumbs: false,
          },
          navigation: {
            nextEl: '.featured_image_slider .swiper-button-next',
            prevEl: '.featured_image_slider .swiper-button-prev',
          },
        });

        // Function to update variant image
        function updateVariantImage() {
          const variantSelects = document.querySelector('variant-selects');
          if (!variantSelects) return;

          const variantId = parseInt(variantSelects.getAttribute('data-selected-id'));
          //console.log('Initial variant ID:', variantId);
          
          if (variantId) {
            const product = JSON.parse(document.getElementById('product-json').textContent);
            
            // Find the variant and update slider
            for (let variant of product.variants) {
              if (variant.id === variantId && variant.featured_image) {
                const slideElement = document.querySelector(`[data-variant-image-id="${variant.featured_image.id}"]`);
                if (slideElement) {
                  const slideIndex = parseInt(slideElement.getAttribute('data-index'));
                  //console.log('Initial slide index:', slideIndex);
                  featured_image_slider.slideTo(slideIndex);
                }
                break;
              }
            }
          }
        }

        // Update variant image on page load
        updateVariantImage();

        // Handle variant changes
        document.addEventListener('change', function(event) {
          const target = event.target;
          //console.log('Change event triggered on:', target);
          
          // Check if the change is from a variant select inside variant-selects component
          if (target.closest('variant-selects') && target.tagName === 'INPUT') {
            //console.log('Variant select changed');
            updateVariantImage();
          }
        });
      }
    }, 100);

});